import Vue from 'vue'

import Qs from 'qs'

class Events {
  async index({params}) {
    return await Vue.axios
      .get('app/events', {
        params,
        paramsSerializer: (params) => {
          return Qs.stringify(params)
        }
      })
  }

  async create({data}) {
    return await Vue.axios
      .post('app/events', data)
  }

  async read({id}) {
    return await Vue.axios
      .get('app/events/' + id)
  }

  async update({id, data}) {
    return await Vue.axios
      .put('app/events/' + id, data)
  }

  async delete({id}) {
    return await Vue.axios
      .delete('app/events/' + id)
  }
}

const events = new Events()

export default events
